import {
  GET_PETITION_CSV_GENERATION_JOB_SUCCESS,
  GET_PETITION_CSV_GENERATION_JOB_FAILED,
  POST_GENERATE_PETITIONS_CSV_REQUEST,
  POST_GENERATE_PETITIONS_CSV_SUCCESS,
  POST_GENERATE_PETITIONS_CSV_FAILED,
  RESET_GENERATE_PETITIONS_CSV,
} from './actionTypes';

const initialState = {
  loading: false,
  jobId: null,
  generatedCSVUrl: null,
};

const generateCSVReducer = (state = initialState, { type, data, jobId }) => {
  switch (type) {
    case POST_GENERATE_PETITIONS_CSV_REQUEST:
      return { ...state, loading: true };
    case POST_GENERATE_PETITIONS_CSV_SUCCESS:
      return { ...state, jobId };
    case POST_GENERATE_PETITIONS_CSV_FAILED:
    case GET_PETITION_CSV_GENERATION_JOB_FAILED:
      return { ...state, loading: false };
    case GET_PETITION_CSV_GENERATION_JOB_SUCCESS:
      if (data.status === 'SUCCESSFUL') {
        return { ...state, loading: false, generatedCSVUrl: data.file_url };
      }
      return state;
    case RESET_GENERATE_PETITIONS_CSV:
      return initialState;
    default:
      return state;
  }
};

export default generateCSVReducer;
